<template>
  <div>
    <template v-if="is_edit" v-click-outside="on_cancel">
      <base-input
        v-model.trim="local_value"
        :loading="loading"
        @on-save="on_save"
        @on-cancel="on_cancel"
      />
    </template>
    <template v-else>
      <slot :value="value"></slot>
    </template>
  </div>
</template>

<script>
  import BaseInput from '@shared/components/editable-base-input';
  import { mapActions } from 'vuex';
  import { EditableProps } from '@shared/mixins/editable-props';
  import { directive as clickOutside } from 'v-click-outside-x';
  import { WorksheetService } from '@pbx/services/WorksheetService';

  export default {
    components: {
      BaseInput
    },

    directives: {
      clickOutside
    },

    mixins: [EditableProps],

    data: () => ({
      loading: false
    }),

    methods: {
      ...mapActions('pbx/worksheets/table', ['updateItemById']),

      on_save: function() {
        this.loading = true;

        WorksheetService.editItem(this.id, { name: this.local_value })
          .then(res => {
            this.updateItemById(res);
            this.$emit('on-save', res);
            this.$emit('on-complete');
            this.$emit('input', this.local_value);
          })
          .finally(() => (this.loading = false));
      },

      on_cancel: function() {
        this.local_value = this.value;
        this.$emit('on-cancel');
        this.$emit('on-complete');
      }
    }
  };
</script>
